export default __webpack_public_path__ + "static/media/dealer.ac19490e.svg";